(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionDeleteController',FrequentlyAskedQuestionDeleteController);

    FrequentlyAskedQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'FrequentlyAskedQuestion'];

    function FrequentlyAskedQuestionDeleteController($uibModalInstance, entity, FrequentlyAskedQuestion) {
        var vm = this;

        vm.frequentlyAskedQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FrequentlyAskedQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
